import {
    EloquaInteraction,
    ResponsysInteraction,
    SyncLogRecord,
    SyncRejectRecord,
} from '../../../models/appstats/appstats-eloqua.model';
import { PipeTransform } from '@angular/core';

export class EloquaInteractionResult {
    type?: string;
    items?: EloquaInteraction[];
}

export type ResponsysInteractionResult = {
    type?: string;
    items?: ResponsysInteraction[];
};
export type DateRange = {
    start: string;
    end: string;
};

export class AppSpecificErrorLink {
    errorType?: string;
    linkText?: string;
}

export class NavigationData {
    syncLogData?: SyncLogRecord[];
    syncId?: string;
    executionId?: string;
    dateRange?: DateRange;
    syncRejectData?: SyncRejectRecord[];
    syncStatusCode?: string;
}

export type ErrorCount = {
    count?: number;
    key?: string;
};

export type ErrorDetail = {
    errorMessage: string;
    errorIndex?: number;
    errorCount?: number;
    errorRecordIds?: string[];
    errorType?: string;
};

export type ErrorColumn = {
    property: string;
    label: string;
    /** Optional CSS class applied to both the header and data cells for this column */
    cssClass?: string;
    /** Optional array of PipeTransform instances applied in order to the cell value */
    pipes?: PipeTransform[];
};
